//////// GHG 1_2
const oneTwoSchema = {
  title: "1.2 Direct Emissions from Mobile Combustion",
  addAPI: "cat1_2AddEmissionActivityAPI",
  cat: "cat1_2",
  EATitle: "Emission Activity",
  fields: [
    {
      key: "activityId",
      level: 1,
      type: "select",
      label: "Vehicle Model",
      optionsAPI: "mobileCombustionEmissionActivityAPI",
      required: true,
    },
    {
      key: "itemName",
      level: 1,
      type: "input",
      label: "Name / Number",
      resetOnChange: false,
      required: true,
    },
    {
      key: "isBiomassActivity",
      level: 1,
      type: "trigger",
      label: "Biomass",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
      defaultValue: false,
      tooltip: 'If biomass / biofuel / biogas is used, click "Yes".',
      required: true,
      resetOnChange: true,
    },
    {
      key: "isBiomassSeparate",
      level: 2,
      type: "trigger",
      label: "Report each greenhouse gas separately ?",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
      defaultValue: false,
      required: true,
      resetOnChange: true,
      showIf: {
        all: [
          { level: 1, key: "isBiomassActivity", eq: true },
          { level: 1, key: "isBiomassActivity", notEmpty: true },
        ],
      },
    },
  ],
};

export default oneTwoSchema;
